export { default } from "./useCanSeeQuizStandards";
